export function setSource (source) {
  return (dispatch) => dispatch({
    type: 'SET_SOURCE',
    source,
  });
}
